import $ from 'jquery';

export default {
  init() {
    
    // Category picker.
    // On multiple pages so dumped here rather than a route.
    $('#cat').on('change', function() {
      const id = $(this).val();
      const url = '/index.php?cat=' + id;
      window.location = url;
    });

    /**
     * Mobile Nav
     */

    const moreNav = $('#more-nav');
    $('#menu-mobile-nav li:last-child').on('click', function (e) {
      e.preventDefault();
      moreNav.fadeIn();
    });

    $('a[href="#"]').on('click', function (e) {
      e.preventDefault();
    });

    $('#more-close').on('click', function () {
      moreNav.fadeOut();
    });
    
    /**
     * Carousel
     */

    
    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js